"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
/**
 * Logic copied directly from https://www.simoahava.com/analytics/track-browsing-behavior-in-google-analytics/
 */
class BrowserTracker {
    constructor() {
        this.tabId = "";
        this.openTabs = [];
        this.isNewTab = true;
        this.redirectCount = 0;
        this.navigationType = "";
        // Tab expiration in milliseconds. The recommended default is 72 hours (259200000 ms), or 0 to deactivate.
        this.tabTTL = 259200000;
        this.NOW = new Date().getTime();
        this.removeTabOnUnload = () => {
            // Get the most recent values from storage
            const openTabs = this.getFromLocalStorage("_tab_ids", []);
            const tabId = this.getFromSessionStorage("_tab_id", "", false);
            const unexpiredTabs = this.getUnexpiredTabs(openTabs);
            if (unexpiredTabs.length && tabId) {
                const i = unexpiredTabs.indexOf(tabId);
                if (i > -1) {
                    unexpiredTabs.splice(i, 1);
                }
                localStorage.setItem("_tab_ids", JSON.stringify(unexpiredTabs));
            }
        };
        this.getUnexpiredTabs = (tabIds) => {
            if (this.tabTTL === 0) {
                return tabIds;
            }
            return tabIds.filter(tabId => {
                try {
                    const expiration = parseInt(tabId.split("_")[1], 10);
                    return expiration > this.NOW;
                }
                catch (e) {
                    return false;
                }
            });
        };
        this.setNavPath = (isBackForward) => {
            // Load nav path if it exists in session storage.
            const navPath = this.getFromSessionStorage("_nav_path", []);
            const curPage = document.location.href;
            const origin = document.location.origin;
            const isDifferentPage = navPath.length && navPath[navPath.length - 1] !== curPage;
            const fromSameDomain = document.referrer.indexOf(origin) > -1;
            let navigationType = "";
            // Only track new tabs if navigation type is NAVIGATE or OTHER
            const perfNavigationType = window.performance.navigation.type;
            const shouldComputeNavigationType = !this.isNewTab || perfNavigationType === 0 || perfNavigationType === 255;
            if (!shouldComputeNavigationType) {
                navPath.push(curPage);
            }
            else {
                if (isBackForward || perfNavigationType === 2) {
                    navigationType = this.getBackForwardNavigation(navPath, curPage);
                    if (navigationType === "FORWARD" && fromSameDomain) {
                        // Only add to navigation if not coming from external domain
                        navPath.push(curPage);
                    }
                    else if (navigationType === "BACK" && isDifferentPage) {
                        // Only clear from navigation if not returning from external domain
                        navPath.pop();
                    }
                    else {
                        navPath.push(curPage);
                    }
                }
                else if (perfNavigationType === 1) {
                    navigationType = "RELOAD";
                    if (navPath.length === 0 || isDifferentPage) {
                        navPath.push(curPage);
                    }
                }
                else if (perfNavigationType === 0) {
                    navigationType = "NAVIGATE";
                    navPath.push(curPage);
                }
                else {
                    navigationType = "OTHER";
                    navPath.push(curPage);
                }
            }
            this.navigationType = navigationType;
            this.redirectCount = window.performance.navigation.redirectCount;
            sessionStorage.setItem("_nav_path", JSON.stringify(navPath));
        };
        this.getBackForwardNavigation = (navPath, curPage) => {
            if (navPath.length < 2) {
                return "FORWARD";
            }
            const prevInStack = navPath[navPath.length - 2];
            const lastInStack = navPath[navPath.length - 1];
            if (prevInStack === curPage || lastInStack === curPage) {
                return "BACK";
            }
            else {
                return "FORWARD";
            }
        };
        this.getFromLocalStorage = (key, def = null, deserialize = true) => {
            const item = localStorage.getItem(key);
            return item && deserialize ? JSON.parse(item) : item || def;
        };
        this.getFromSessionStorage = (key, def = null, deserialize = true) => {
            const item = sessionStorage.getItem(key);
            return item && deserialize ? JSON.parse(item) : item || def;
        };
        this.recordPageLoad();
        if (window.Storage) {
            window.addEventListener("beforeunload", this.removeTabOnUnload);
        }
    }
    /**
     * Used for SPAs.
     */
    recordPageLoad(isBackForward = false) {
        if (window.Storage) {
            this.setTabId();
            this.setOpenTabs();
            if (window.PerformanceNavigation) {
                this.setNavPath(isBackForward);
            }
        }
    }
    getPageInfo() {
        return {
            tabId: this.tabId.replace(/_.+/, ""),
            tabCount: this.openTabs.length,
            newTab: this.isNewTab ? "New" : "Existing",
            redirectCount: this.redirectCount,
            navigationType: this.navigationType
        };
    }
    setOpenTabs() {
        const storedTabs = this.getFromLocalStorage("_tab_ids", []);
        const unexpiredTabs = this.getUnexpiredTabs(storedTabs);
        // Save this tab in openTabs
        if (this.tabId && !unexpiredTabs.includes(this.tabId)) {
            unexpiredTabs.push(this.tabId);
        }
        // save in localstorage
        this.openTabs = unexpiredTabs;
        localStorage.setItem("_tab_ids", JSON.stringify(unexpiredTabs));
    }
    setTabId() {
        // Load tabId from storage if it is there.
        let tabId = this.getFromSessionStorage("_tab_id", "", false);
        let isNewTab = false;
        if (tabId && this.tabTTL !== 0) {
            const tabIdParts = tabId.split("_");
            const tabExpiration = parseInt(tabIdParts[1], 10);
            // Update the tab expiration if it has expired.
            if (tabExpiration <= this.NOW) {
                const newExpiration = this.NOW + this.tabTTL;
                tabId = tabIdParts[0] + "_" + newExpiration;
            }
        }
        else if (!tabId) {
            // Create new tabId
            isNewTab = true;
            tabId = uuid_1.v4() + (this.tabTTL > 0 ? "_" + (this.NOW + this.tabTTL) : "");
        }
        // save in sessionStorage
        this.tabId = tabId;
        this.isNewTab = isNewTab;
        sessionStorage.setItem("_tab_id", tabId);
    }
}
exports.default = BrowserTracker;
//# sourceMappingURL=BrowserTracker.js.map